import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Grade } from '../../models/Grade';
import { ModalController } from 'ionic-angular';
import { AngularFireDatabase } from '../../../node_modules/angularfire2/database';
import { CoinsProvider } from './../coins/coins';
import { UserProvider } from '../user/user';
import { ThenableReference } from '../../../node_modules/@firebase/database-types';

import { AddGradeComponent } from '../../components/add-grade/add-grade';
import { Observable } from 'rxjs/Observable';
import "rxjs/add/operator/catch"
import { combineLatest } from 'rxjs/observable/combineLatest';

@Injectable()
export class GradesProvider {

    allGrades: Observable<Grade[]>;
    allGradesStocks: Observable<Grade[]>;

    constructor(
        private db: AngularFireDatabase,
        private user: UserProvider,
        private modalCtrl: ModalController
    ) {
        this.allGrades = this.getAllGradesObservable(false).shareReplay(1);
        this.allGradesStocks = this.getAllGradesObservable(true).shareReplay(1);
    }

    private getAllGradesObservable(stocks = false): Observable<Grade[]> {
        let path = `grades`;
        if(stocks) path = 'grades-stocks';

        return combineLatest(this.user.hasAccess(), this.user.isAdmin()).switchMap(access => {
            let hasAccess = access[0];
            let isAdmin = access[1];
            if (!(hasAccess || isAdmin)) return Observable.of([]);
            return this.db.list<Grade>(path, ref => ref.orderByChild('timestamp'))
                .snapshotChanges()
                .map(snapshot => {
                    let grades = [];
                    for (let snap of snapshot) {
                        const grade: Grade = snap.payload.val();
                        grade.key = snap.key;
                        grades.push(grade)
                        // console.log(liveSignal.key);
                    }
                    return grades.reverse();
                }).catch((error, caught) => {
                    console.log(error);
                    return Observable.of([]);
                })
        })
    }

    public getAllGrades(stocks = false): Observable<Grade[]> {
        if(stocks) return this.allGradesStocks;
        return this.allGrades;
    }

    public addGrade(grade: Grade): ThenableReference {
        let path = 'grades';
        if(grade.isStock) path = 'grades-stocks';

        return this.db.database.ref(path).push(grade);
    }

    public editGrade(grade: Grade): Promise<void> {
        if (!grade.key) return;
        let path = `grades/${grade.key}`;
        if(grade.isStock) path = `grades-stocks/${grade.key}`;
        return this.db.database.ref(path).update(grade);
    }

    public removeGrade(grade: Grade): Promise<void> {
        if (!grade.key) return;
        let path = `grades/${grade.key}`
        if(grade.isStock) path = `grades-stocks/${grade.key}`

        return this.db.database.ref(path).remove();
    }

    public openGrade(grade: Grade) {
        let modal = this.modalCtrl.create(AddGradeComponent, { grade: grade });
        modal.present();
    }

    public getGradeById(id: string, isStock: boolean): Promise<Grade> {
        let observable = isStock ? this.allGradesStocks : this.allGrades;
        return observable.first().toPromise()
            .then(grades => {
                for (let grade of grades) {
                    if (grade.key == id) return grade;
                }
                return null;
            })
            .catch(error => { return null });
    }

}



// WEBPACK FOOTER //
// ./src/providers/grades/grades.ts